import { AxiosError } from 'axios';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import targetMenuService from 'components/SelectTargetMenuModal/services';
import { MenuClassification } from 'features/MenuList/models/menu';
import { FormEvent, useEffect, useRef, useState } from 'react';
import { Accordion, Button, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { displayError, handleServiceError } from 'utils';

export interface FormSearchValueProps {
  menuClassificationId: string;
  name: string;
  cd: string;
}

interface SelectTargetMenuModalFilterProps {
  onFilter: (formSearchValue: FormSearchValueProps) => void;
}

function SelectTargetMenuModalFilter({ onFilter }: SelectTargetMenuModalFilterProps) {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();

  // states
  const [menuClassifications, setMenuClassifications] = useState<MenuClassification[]>([]);
  const [formSearchValue, setFormSearchValue] = useState<FormSearchValueProps>({
    menuClassificationId: '',
    name: '',
    cd: '',
  });

  // refs
  const formSearchRef = useRef<HTMLFormElement>(null);

  // effects
  useEffect(() => {
    loadMenuClassfications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function loadMenuClassfications() {
    (async () => {
      try {
        const response = await targetMenuService.getMenuClassification();
        setMenuClassifications(response.data);
      } catch (e) {
        if (!handleServiceError(showGlobalModal, e as AxiosError)) {
          displayError(showGlobalModal, e as AxiosError);
        }
      }
    })();
  }

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    // handleUnSelectAll();
    // loadMenuListData();
    if (formSearchRef.current) {
      const formValue: FormSearchValueProps = {
        menuClassificationId: formSearchRef.current['search_menuClassificationId'].value.trim(),
        name: formSearchRef.current['search_name'].value.trim(),
        cd: formSearchRef.current['search_cd'].value.trim(),
      };
      onFilter(formValue);
    }
  }

  function saveFormSearch() {
    if (formSearchRef.current) {
      setFormSearchValue({
        ...formSearchValue,
        menuClassificationId: formSearchRef.current['search_menuClassificationId'].value.trim(),
        name: formSearchRef.current['search_name'].value.trim(),
        cd: formSearchRef.current['search_cd'].value.trim(),
      });
    }
  }

  return (
    <form ref={formSearchRef} className="mt-3 mb-3" onSubmit={handleSubmit}>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{t('MenuBookListPage.search')}</Accordion.Header>
          <Accordion.Body onExited={saveFormSearch}>
            <Row>
              <Col>
                <Row className="mb-3">
                  <Col sm={3} className="text-end">
                    <Form.Label htmlFor="cbo-menu-classification-id" className="col-form-label">
                      {t('SelectTargetMenuModal.menu_classification')}：
                    </Form.Label>
                  </Col>
                  <Col sm={4}>
                    <Form.Select
                      id="cbo-menu-classification-id"
                      name="search_menuClassificationId"
                      className="text-center"
                    >
                      <option key={-1} value="">
                        ------- 全て -------
                      </option>
                      {menuClassifications &&
                        menuClassifications.map((value: MenuClassification) => (
                          <option key={value.id} value={value.id}>
                            {value.name}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={3} className="text-end">
                    <Form.Label htmlFor="txt-menu-name" className="col-form-label">
                      {t('SelectTargetMenuModal.name')}：
                    </Form.Label>
                  </Col>
                  <Col sm={4}>
                    <Form.Control id="txt-menu-name" name="search_name" />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={3} className="text-end">
                    <Form.Label htmlFor="txt-menu-code" className="col-form-label">
                      {t('SelectTargetMenuModal.menu_code')}：
                    </Form.Label>
                  </Col>
                  <Col sm={4}>
                    <Form.Control id="txt-menu-code" name="search_cd" />
                  </Col>
                  <Col sm={5} className="text-end">
                    <Button type="submit">{t('SelectTargetMenuModal.search')}</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Accordion.Body>
          <div className="accordion-body accordion-summary">
            <Row>
              <Col sm={'auto'}>
                <Form.Label className="col-form-label">{t('SelectTargetMenuModal.menu_classification')}：</Form.Label>
                <Form.Label className="col-form-label">
                  {menuClassifications.find((value) => value.id === parseInt(formSearchValue.menuClassificationId))
                    ?.name || '-'}
                </Form.Label>
              </Col>

              <Col sm={'auto'}>
                <Form.Label className="col-form-label">{t('SelectTargetMenuModal.name')}：</Form.Label>
                <Form.Label className="col-form-label">{formSearchValue.name || '-'}</Form.Label>
              </Col>

              <Col sm={'auto'}>
                <Form.Label className="col-form-label">{t('SelectTargetMenuModal.menu_code')}：</Form.Label>
                <Form.Label className="col-form-label">{formSearchValue.cd || '-'}</Form.Label>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </form>
  );
}

export default SelectTargetMenuModalFilter;
